"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskWatchItem = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const TaskStatus_1 = __importDefault(require("@opsbase/lib-task/TaskStatus"));
const CheckIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckIcon"));
const CloseIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CloseIcon"));
const ErrorIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ErrorIcon"));
const FileUploadIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FileUploadIcon"));
const TimelapseIcon_1 = __importDefault(require("@opsbase/web-icons/icons/TimelapseIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function TaskWatchItem(props) {
    var _a, _b;
    const { task, onClose = doNothing_1.default } = props;
    const handleClickClose = (0, react_1.useCallback)(() => {
        onClose(task);
    }, [task, onClose]);
    const icon = task.status === TaskStatus_1.default.FAILURE ? (react_1.default.createElement(ErrorIcon_1.default, { color: lib_palette_1.default.error })) : task.status === TaskStatus_1.default.SUCCESS ? (react_1.default.createElement(CheckIcon_1.default, { color: lib_palette_1.default.positive })) : (react_1.default.createElement(TimelapseIcon_1.default, { color: lib_palette_1.default.progress }));
    const failureReason = task.status === TaskStatus_1.default.FAILURE
        ? task.response.failureReason || 'Unexpected failure'
        : undefined;
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, style: { minWidth: 300 } },
            react_1.default.createElement(Pane_1.default, null, icon),
            react_1.default.createElement(Pane_1.default, { grow: true }, task.title),
            task.isFinished && ((_a = task.response) === null || _a === void 0 ? void 0 : _a.downloadUrl) && (react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Button_1.default, { small: true, target: "_blank", link: (_b = task.response) === null || _b === void 0 ? void 0 : _b.downloadUrl, label: lib_i18n_1.default.t('download'), icon: react_1.default.createElement(FileUploadIcon_1.default, null) }))),
            react_1.default.createElement(Pane_1.default, null,
                !task.isFinished && react_1.default.createElement(Dots_1.default, { color: lib_palette_1.default.progress }),
                task.isFinished && (react_1.default.createElement(IconButton_1.default, { icon: react_1.default.createElement(CloseIcon_1.default, null), onClick: handleClickClose })))),
        !!failureReason && react_1.default.createElement(Text_1.default, { withBreaks: true }, failureReason)));
}
exports.TaskWatchItem = TaskWatchItem;
exports.default = TaskWatchItem;
